export default "__VITE_ASSET__B5efOv_z__"